import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ListScenarioComponent } from './list-scenario/list-scenario.component';
import { CreateScenarioComponent } from './create-scenario/create-scenario.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormField, MatFormFieldModule } from '@angular/material/form-field';
import { NgxSliderModule } from '@angular-slider/ngx-slider';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { MatMenuModule } from '@angular/material/menu';
import { MatInputModule } from '@angular/material/input';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatRadioModule } from '@angular/material/radio';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatSelectModule } from '@angular/material/select';
import { MatDialogModule } from '@angular/material/dialog';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatTableModule } from '@angular/material/table';
import { MatListModule } from '@angular/material/list';
import { AgGridModule } from 'ag-grid-angular';



@NgModule({
  declarations: [
    ListScenarioComponent,
    CreateScenarioComponent
  ],
  imports: [
    FormsModule,
    CommonModule,
    NgxSliderModule,    
    MatButtonModule,    
    MatButtonToggleModule,
    DragDropModule,
    MatMenuModule,    
    MatInputModule,
    MatExpansionModule,
    MatRadioModule,
    MatFormFieldModule,
    MatCheckboxModule,
    MatSelectModule,
    MatDialogModule,
    MatAutocompleteModule,
    MatTableModule,
    MatListModule,
    ReactiveFormsModule,
    AgGridModule,
    MatIconModule
  ],
  exports: [
    ListScenarioComponent,
    CreateScenarioComponent
  ]
})
export class ScenarioModule { }
